import React, { useContext, useEffect, useRef, useState } from 'react'
import { AuthContext } from '../../hooks/context/authContext';
import { useHistory } from 'react-router-dom';
import { NavDropdown } from 'react-bootstrap';
import TableMaternidad from './TableMaternidad'
import { ROLES } from '../../constants/hardCodedConstants';
import PageHeader from '../../components/pageHeader/PageHeader';
import PageWrapper from '../../components/pageComponents/PageWrapper';
import PageButtons from '../../components/pageComponents/PageButtons';
import ModalEnabled from '../../components/modalComponents/ModalEnabled';
import SearchContainer from '../../components/pageComponents/SearchContainer';
import { useGetRequest } from '../../hooks/useGetRequest/useGetRequest';
import useDidMountEffect from '../../hooks/useDidMountEffect/useDidMountEffect';
import { useManagePostRequest } from '../../hooks/useManagePostRequest/useManagePostRequest';
import { useGenerarDescargarEliminarArchivo } from '../../hooks/useGenerarDescargarEliminarArchivo/useGenerarDescargarEliminarArchivo';
import { initialAllOptionPromises, jsonNoEstaVacio, updateFiltersWithExtraData, usuarioLogueadoTieneAlgunoDeLosSiguientesRoles } from '../../helper/utils';
import {
  descargarExcelMaternidadAPI,
  getAllCargosAPI,
  getAllEstadosAPI,
  getAllSedesAPI,
  getListaCondicionAPI,
  getMotivoTerminoMaternidadAPI,
  getAllTipoCondicionAPI,
  getAllDepartamentosAPI,
  getAllTiposLicenciasAPI, getAllNivelesAprobacionCondicionAPI,
  registrarEnOfisisBatchAPI
} from '../../consumers/backendApisUrls';
import CrearMaternidad from './modales/CrearMaternidad';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import NivelesAprobacion from "./modales/NivelesAprobacion/NivelesAprobacion";
import TiposLicencia from "./modales/TiposLicencia/TiposLicencia";

const INIT_KEYS = {
  departamentos: "IdsDepartamentos",
  cargos: "IdsCargos",
  sedes: "IdsSedes",
  
  estadoEmpleado: "IdsEstadosEmpleado",
  
  estadosAprobacion: "IdsEstadosAprobacion",
  estadoProceso: "IdsEstadosProceso",
  
  condicion: "IdsTipoDeCondicion",
  motivo: "IdsMotivoTerminoMaternidad",

  preExistencia: "IdsPreExistencia",
  subsidio: "IdsTieneSubsidio",
  registradoEnOfisis: "IdsRegistradoEnOfisis",

  IdsTipoLicenciaCondicion: "IdsTipoLicenciaCondicion",
  IdsNivelesAprobacion:"IdsNivelesAprobacion"
};

const GestionMaternidad = () => {

  const { state } = useContext(AuthContext);
  const history = useHistory();
  const isAdmin = usuarioLogueadoTieneAlgunoDeLosSiguientesRoles(state.roleIds, [ROLES.SuperAdmin.id, ROLES.Compensaciones.id, ROLES.Bienestar.id]);

  const [formValues, setFormValues] = useState({ Items: [], ExtraData: {}, filters: [], selectedFilters: {} });
  const [allFilters, setAllFilters] = useState([]);

  const [searchCriteria, setSearchCriteria] = useState("");
  const [paginator, setPaginator] = useState({ CurrentPage: 1 });
  const [isLoading, setIsLoading] = useState(true);

  const [modalEnabled, setModalEnabled] = useState({ isEnable: false, component: React.Fragment });
  const [selectedIds, setSelectedIds] = useState(new Set());
  const selectAllRef = useRef(null);

  const [executeGet] = useGetRequest();
  const [executeManagePost] = useManagePostRequest();
  const [downloaAndDeletedReport] = useGenerarDescargarEliminarArchivo();

  const initialPromises = () => {
    const response = executeGet(getAllEstadosAPI());

    return [
      executeGet(getAllDepartamentosAPI()),      // 1. departamentos
      executeGet(getAllCargosAPI()),             // 2. cargos
      executeGet(getAllSedesAPI()),              // 3. sedes
      response,                                   // 4. estadoEmpleado
      response,                                   // 5. estadosAprobacion
      response,                                   // 6. estadoProceso
      executeGet(getAllTipoCondicionAPI()),      // 7. condicion
      executeGet(getMotivoTerminoMaternidadAPI()),// 8. motivo
      response,                                   // 9. preExistencia
      response,                                   // 10. subsidio
      response,                                   // 11. registradoEnOfisis
      executeGet(getAllTiposLicenciasAPI()),     // 12. IdsTipoLicenciaCondicion
      executeGet(getAllNivelesAprobacionCondicionAPI()) // 13. IdsNivelesAprobacion
    ];
  }

  const init = async () => {
    setIsLoading(true);
    try {
      await initialAllOptionPromises(initialPromises, Object.values(INIT_KEYS), setAllFilters);
      await manageSearch();
      if (formValues.filters.length === 0) {
        jsonNoEstaVacio(formValues.ExtraData) && updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  const manageSearch = async () => {
    const api = getListaCondicionAPI();
    const payload = getPayload();
    await executeManagePost(api, payload, successManageSearchCallback);
  }

  const getPayload = () => {
    return {
      Criteria: searchCriteria,
      Page: paginator.CurrentPage,
      ...formValues.selectedFilters
    }
  }

  const successManageSearchCallback = ({ data }) => {
    const { Items, ExtraData, TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage } = data;
    setFormValues(lastData => ({ ...lastData, Items, ExtraData }));
    setPaginator({ TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage });
  }

  const handleDescargar = async () => {
    const api = descargarExcelMaternidadAPI();
    const payload = getPayload();
    await downloaAndDeletedReport(api, payload);
  }

  const handleRegistrarEnOfisisBatch = async () => {
    const api = registrarEnOfisisBatchAPI();
    const payload = { Ids: Array.from(selectedIds), RegistradoEnOfisis: true, IdUsuario: state?.user?.IdUsuario || state?.user?.id };
    await executeManagePost(api, payload, () => {
      setSelectedIds(new Set());
      manageSearch();
    });
  }

  const handleUpdatedFilters = (res) => {
    setFormValues(lastData => ({ ...lastData, filters: res }))
  }

  const handleCleanSearch = () => {
    setFormValues({ ...formValues, selectedFilters: null });
  }

  useDidMountEffect(() => {
    manageSearch();
  }, [paginator.CurrentPage, formValues.selectedFilters])

  useDidMountEffect(() => {
    jsonNoEstaVacio(formValues.ExtraData) && updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
  }, [formValues.ExtraData])

  useEffect(() => {
    init();
  }, [])

  const PageButtonsComponent = (
      <div className="d-flex">
        <PageButtons>
          <NavDropdown id={"navDropdown-misSolicitudesBeneficios"}
                       className="generic-button-dropdown"
                       title={<span className="generic-button-dropdown-title">Acciones</span>}>

            {formValues?.ExtraData?.PuedeCrearCondicion === true &&
                <NavDropdown.Item onClick={() =>
                    setModalEnabled({ isEnable: true, component: CrearMaternidad, data: { isAdmin: true, idEmpleado: 0} })
                }>Crear Nuevo
                </NavDropdown.Item>
            }


            <NavDropdown.Item
                onClick={() => history.push("/registroCondicion/asistenciaLactario")}>
              Asistencia Lactario
            </NavDropdown.Item>
            <NavDropdown.Item onClick={handleDescargar}>Descargar</NavDropdown.Item>

          </NavDropdown>
        </PageButtons>
        {formValues?.ExtraData?.PuedeToggleRegistradoEnOfisis && selectedIds.size > 0 && (
          <PageButtons>
            <button type='button'
              className='generic-button-buscador'
              style={{ background: '#28a745', color: '#fff' }}
              onClick={handleRegistrarEnOfisisBatch}>
              Registrar en Ofisis ({selectedIds.size})
            </button>
          </PageButtons>
        )}
        {formValues?.ExtraData?.PuedeConfigurarLicencias === true &&
          <PageButtons>
            <NavDropdown id={"navDropdown-configuracion-maternidad"}
                         className=""
                         title={<span className="align-items-center p-2 ml-2" style={{ backgroundColor: 'gray', borderRadius: '50%' }}
                                      onClick={() => {}}
                         >
                    <FontAwesomeIcon icon='cog' size="lg" className="hand-pointer white" style={{ color: 'white' }} title="Configurar Licencias" />
                </span>}>


              <NavDropdown.Item onClick={() =>
                  setModalEnabled({ isEnable: true, component: NivelesAprobacion, data: { } })
              }>Niveles Aprobación
              </NavDropdown.Item>

              <NavDropdown.Item onClick={() =>
                  setModalEnabled({ isEnable: true, component: TiposLicencia, data: { } })
              }>Tipos de Licencias
              </NavDropdown.Item>

            </NavDropdown>
          </PageButtons>
        }
      </div>

  );

  return (
    <PageWrapper isLoading={isLoading}>
      <ModalEnabled
        modalEnabled={modalEnabled}
        setModalEnabled={setModalEnabled}
        refreshPage={manageSearch}
      />
      <PageHeader title="Listado de registros de DM y/o maternidad" />
      <SearchContainer
        searchCriteria={searchCriteria}
        setSearchCriteria={setSearchCriteria}
        setPaginator={setPaginator}
        manageSearch={manageSearch}
        addCleanSearch={handleCleanSearch}>
        {PageButtonsComponent}
      </SearchContainer>

        <TableMaternidad
            formValues={formValues}
            setFormValues={setFormValues}
            extraData={formValues.ExtraData}
            setModalEnabled={setModalEnabled}
            paginator={paginator}
            setPaginator={setPaginator}
            keys={INIT_KEYS}
            isAdmin={isAdmin}
            fromAdminPage={true}
            manageSearch={manageSearch}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
            selectAllRef={selectAllRef}
        />


    </PageWrapper>
  );
}

export default GestionMaternidad